import moment from "moment";
import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTDatePicker } from "commonComponents/btWrappers/BTDatePicker/BTDatePicker";
import { BTTimePicker } from "commonComponents/btWrappers/BTTimePicker/BTTimePicker";
import { DateDisplay } from "commonComponents/utilities/DateDisplay/DateDisplay";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";

type ResponseType = string | null;
type CellType = moment.Moment | undefined;

class DateTimeFilterCell extends PureComponent<IGridFilterCellRenderProps<ResponseType, CellType>> {
    render() {
        const {
            cellValue,
            field: { full: id },
            onChange,
        } = this.props;
        return (
            <>
                <BTDatePicker<undefined>
                    id={id}
                    data-testid={`${id}_Date`}
                    value={cellValue || undefined}
                    onChange={onChange}
                />
                <BTTimePicker<undefined>
                    id={id}
                    data-testid={`${id}_Time`}
                    value={cellValue || undefined}
                    onChange={onChange}
                />
            </>
        );
    }
}

class DateTimeCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? <DateDisplay value={cellValue} showTime /> : null;
    }
}

export const columnDateTime: IClientGridColumn<ResponseType, CellType> = {
    validationSchema: yup.mixed().validMomentDate("date"),
    columnType: GridColumnType.dateTime,
    mapper: (serverCellResponse) => (serverCellResponse ? moment(serverCellResponse) : undefined),
    FilterCell: DateTimeFilterCell,
    Cell: DateTimeCell,
};
